/**
 * The signed-in user's own Profile page.
 *
 * Not a new feature — `AccountSettingsTab` already did exactly this (name,
 * password, appearance, "my modules") from inside the old Settings drawer.
 * It moves here UNCHANGED: the User Menu's "Profile" now opens it directly,
 * as its own page, and the admin Settings console no longer carries a
 * personal-account tab that has nothing to do with administering the portal.
 */

import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../../auth/AuthContext';
import AccountSettingsTab from './AccountSettingsTab';

export default function ProfilePage({ onBack }: { onBack: () => void }) {
  const { currentUser, refreshCurrentUser } = useAuth();
  if (!currentUser) return null;

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-slate-50">
      <header className="flex flex-shrink-0 items-center gap-3 border-b border-blue-100 bg-blue-50 px-4 py-3 sm:px-6">
        <button
          type="button"
          onClick={onBack}
          className="gl-btn gl-btn--secondary px-2.5 py-1.5 text-[12.5px]"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Back to the portal
        </button>
        <h1 className="text-sm font-semibold text-slate-800">My Profile</h1>
      </header>

      <div className="min-h-0 flex-1 overflow-y-auto px-4 py-6 sm:px-6">
        <div className="mx-auto max-w-2xl">
          <AccountSettingsTab currentUser={currentUser} onProfileUpdated={() => void refreshCurrentUser()} />
        </div>
      </div>
    </div>
  );
}
